import { AppSettings } from '../../Configuration/types';
import { useAppSelector } from '../../store';
import Announcement from '../Announcements/Announcement';

/**
 * Component used for rendering a warning Announcement at the top of the application indicating a non-production environment.
 */
export default function EnvironmentWarning() {
	const environment = useAppSelector((state) => (state.appSettings as AppSettings).environment);

	// While the environment setting is designed to be omitted in production, ensuring we dont render the announcement if someone put production there
	if (
		!environment ||
		environment.localeCompare('Production', 'en', {
			sensitivity: 'base'
		}) === 0
	) {
		return <></>;
	}

	return (
		<Announcement
			uniqueId={1}
			title={environment}
			severity='warning'
			straightEdges
			filled
		/>
	);
}
